import { Formik, Form, Field } from 'formik';
import { useState, useEffect } from 'react';
import { Modal, notification } from 'antd';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import axios from 'axios';

import Footer from '../../components/Footer/Footer';
import Button from '../../components/Button/Button';
import WrongIcon from '../../assets/icons/WrongIcon';
import CheckIcon from '../../assets/icons/CheckIcon';

import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import 'antd/dist/antd.min.css';
import Verified from '../../assets/icons/Verified';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import {
  login,
  retrieveQuestion,
  confirmAccount,
} from '../../services/authService';
import Students from '../../assets/icons/Students';
import School from '../../assets/icons/School';
import User from '../../assets/icons/User';
import Header from '../../components/Header/Header';
import { baseURL } from '../../utils/axios';
import ReactPixel from 'react-facebook-pixel';

const Login = () => {
  const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [resetVisible, setResetVisible] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [question, setQuestion] = useState('');
  const [userSelection, setUserSelection] = useState('');
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    ReactPixel.pageView(); // Track a page view event
  }, []);

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setConfirmVisible(false);
  };

  const handleResetOk = () => {
    setResetVisible(false);
  };

  const handleResetCancel = () => {
    setResetVisible(false);
  };

  const initialValues = {
    email: '',
    password: '',
  };

  //get user question
  const retrieveUserQuestion = async (data) => {
    setLoading(true);
    try {
      let res = await retrieveQuestion({ email: data });
      setQuestion(res.data.securityQuestion);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notification['error']({
        message: error.response.data.message.errors.email[0],
      });
      setLoading(false);
    }
  };

  //login
  const loginUser = async (data) => {
    if (userSelection === '') {
      notification['info']({
        message: 'Please select a user type',
      });
      return;
    }

    try {
      setLoading(true);
      let res = await login(data);

      if (userSelection === '1') {
        localStorage.setItem('token', res.data.accessToken);
        localStorage.setItem('userData', JSON.stringify(res.data.student));
      } else {
        localStorage.setItem('token', res.data.accessToken);
        localStorage.setItem('userData', JSON.stringify(res.data.teacher));
      }

      setLoading(false);
      if (query.get('cart') === 'true') {
        window.location.replace('/payment');
      }

      if (userSelection === '1') {
        const previousUrl = document.referrer;
        console.log(previousUrl);
        if (previousUrl.includes('student-signup')) {
          window.history.back();
          window.history.back();
        } else {
          window.history.back();
        }
      } else {
        window.location.replace('/tutor-dashboard');
      }
    } catch (error) {
      setLoading(false);
      notification['error']({
        message: error.response.data.message,
      });

      setLoading(false);
    }
  };

  //confirm user account
  const confirmUser = async (data) => {
    setLoading(true);
    try {
      let res = await confirmAccount(data);
      localStorage.setItem('resetToken', res.data.accessToken);
      setLoading(false);
      setIsModalVisible(false);
      setResetVisible(true);
    } catch (error) {
      setLoading(false);
      notification['error']({
        message: error.response.data.message,
      });

      setLoading(false);
    }
  };

  const startResetPassword = async (data) => {
    setLoading(true);

    let token = localStorage.getItem('resetToken');
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };

    try {
      let res = await axios.put(`${baseURL}/auth/reset`, data, {
        headers: headers,
      });
      notification['success']({
        message: 'Password reset successfully',
      });

      setLoading(false);
      setIsModalVisible(false);
      setResetVisible(false);
    } catch (error) {
      setLoading(false);
      notification['error']({
        message: error.response.data.message,
      });

      setLoading(false);
    }
  };

  let query = new URLSearchParams(useLocation().search);

  return (
    <div>
      <Helmet>
        <title>PL by Edves | Login</title>
      </Helmet>
      <Header />

      <div className='login'>
        <div className='login__heading' style={{ paddingTop: '70px' }}>
          <h2>Welcome back</h2>
          {query.get('cart') === 'true' ? (
            <p>You need to sign in first to make payment</p>
          ) : (
            <p>Enter your details correctly to access your account</p>
          )}
        </div>

        <div className='user-selection'>
          <div className='user-selection__wrapper'>
            <div
              className={`user-selection__wrapper__selection ${
                userSelection === '1' ? 'selected-user' : ''
              } `}
              style={{ cursor: 'pointer' }}
              onClick={() => setUserSelection('1')}
            >
              <Students />
              <p>Student</p>
            </div>
            <div className='user-selection__wrapper__vertical-border'></div>
            <div
              className={`user-selection__wrapper__selection ${
                userSelection === '3' ? 'selected-user' : ''
              } `}
              style={{ cursor: 'pointer' }}
              onClick={() => setUserSelection('3')}
            >
              <School />
              <p>Educator</p>
            </div>
          </div>
        </div>
        <div className='login__form'>
          <div className='auth-wrapper__right__form'>
            <Formik
              initialValues={initialValues}
              validationSchema={Yup.object({
                email: Yup.string()
                  .required('Field cannot be empty')
                  .matches(emailReg, 'Invalid Email'),
                password: Yup.string().required('Please Enter your password'),
              })}
              onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(false);

                const data = {
                  ...values,
                  role: userSelection,
                };
                loginUser(data);
              }}
            >
              {({ isValid, dirty, isSubmitting }) => (
                <Form>
                  <div className='auth-wrapper__right__form__inputwrapper'>
                    <label htmlFor='email'>Email Address</label>

                    <Field
                      type='text'
                      name='email'
                      id='email'
                      placeholder='Enter your email address'
                    />
                  </div>

                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ marginBottom: '10px' }}
                  >
                    <label htmlFor='password'>Password</label>

                    <Field
                      type={showPassword ? 'text' : 'password'}
                      name='password'
                      id='password'
                      placeholder='Enter your password'
                    />
                    <div
                      className='eye-icon'
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <AiOutlineEyeInvisible />
                      ) : (
                        <AiOutlineEye />
                      )}
                    </div>
                  </div>
                  <div
                    className='forgot-password-link'
                    onClick={() => setIsModalVisible(true)}
                  >
                    <p> Forgotten your password? </p>
                  </div>

                  <Button
                    text={loading ? 'Please wait...' : 'Log In'}
                    className='primary-btn'
                    width='100%'
                    disabled={isSubmitting || !dirty || !isValid || loading}
                    type='submit'
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <div className='new-user'>
          <p>A new user?</p>
          <p
            className='new-user__second'
            onClick={() =>
              navigate(
                query.get('cart') === 'true'
                  ? '/student-signup?cart=true'
                  : '/student-signup'
              )
            }
          >
            Create your account here
          </p>
        </div>
      </div>

      <Footer />

      <Modal
        width={606}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ padding: '40px' }}>
          <div className='modal-head'>
            <h2>Forgotten Password?</h2>
            <p>
              Enter your registered email address and provide the answer to your
              security question to enable us confirm your account
            </p>
          </div>

          <div className='auth-wrapper__right__form'>
            <Formik
              initialValues={{ email: '', securityAnswer: '' }}
              validationSchema={Yup.object({
                email: Yup.string()
                  .required('Field cannot be empty')
                  .matches(emailReg, 'Invalid Email'),
                securityAnswer: Yup.string().required('Answer is required'),
              })}
              onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(false);
                const data = { ...values, question: question };
                setUserEmail(data.email);
                confirmUser(data);
              }}
            >
              {({ touched, errors, values }) => (
                <Form>
                  <div className='auth-wrapper__right__form__inputwrapper eye-position'>
                    <label htmlFor='email'>Email Address</label>

                    <Field
                      type='email'
                      name='email'
                      id='email'
                      placeholder='Enter your email address'
                      onBlur={() => retrieveUserQuestion(values.email)}
                      className={errors.email ? 'input-error' : ''}
                    />
                    <div className='eye-icon'>
                      {touched.email ? (
                        errors.email ? (
                          <WrongIcon />
                        ) : (
                          <CheckIcon />
                        )
                      ) : (
                        ''
                      )}
                    </div>
                  </div>

                  {loading ? (
                    <p>Please wait...</p>
                  ) : (
                    <div className='auth-wrapper__right__form__inputwrapper'>
                      <label htmlFor='question'>Select Security Question</label>
                      <div className='select-box'>
                        <Field as='select' name='question' id='question'>
                          <option value={question}>{question}</option>
                        </Field>
                      </div>
                    </div>
                  )}

                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ marginBottom: '32px' }}
                  >
                    <label htmlFor='securityAnswer'>Answer</label>

                    <Field
                      type='text'
                      name='securityAnswer'
                      id='securityAnswer'
                      placeholder='Enter your answer here'
                      className={errors.securityAnswer ? 'input-error' : ''}
                    />

                    <div className='eye-icon'>
                      {touched.securityAnswer ? (
                        errors.securityAnswer ? (
                          <WrongIcon />
                        ) : (
                          <CheckIcon />
                        )
                      ) : (
                        ''
                      )}
                    </div>
                  </div>

                  <Button
                    text={'Confirm My Account'}
                    className='primary-btn'
                    width='100%'
                    type='submit'
                    disabled={loading}
                    // onClick={() => {
                    //   setIsModalVisible(false);
                    //   setResetVisible(true);
                    // }}
                  />
                </Form>
              )}
            </Formik>
          </div>

          <div className='flex-center' style={{ marginTop: '25px' }}>
            <p
              className='new-user__second'
              onClick={() => setIsModalVisible(false)}
            >
              Go back to login
            </p>
          </div>
        </div>
      </Modal>

      <Modal
        width={606}
        visible={resetVisible}
        onOk={handleResetOk}
        onCancel={handleResetCancel}
        footer={null}
      >
        <div style={{ padding: '40px' }}>
          <div className='modal-head'>
            <h2>Hello</h2>
            <p>Enter create a new password to reset your password</p>
          </div>

          <div className='auth-wrapper__right__form'>
            <Formik
              initialValues={{ password: '', passwordConfirmation: '' }}
              validationSchema={Yup.object({
                password: Yup.string()
                  .required('Password is required')
                  .min(8, 'Password is too short'),
                passwordConfirmation: Yup.string()
                  .oneOf([Yup.ref('password'), null], `Password doesn't match`)
                  .required('Please confirm password'),
              })}
              onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(false);

                const data = { ...values, email: userEmail };
                startResetPassword(data);
              }}
            >
              {({ isValid, dirty, isSubmitting }) => (
                <Form>
                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ marginBottom: '16px' }}
                  >
                    <label htmlFor='password'>Password</label>

                    <Field
                      type={showPassword ? 'text' : 'password'}
                      name='password'
                      id='password'
                      placeholder='Enter your password'
                    />
                    <div
                      className='eye-icon'
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <AiOutlineEyeInvisible />
                      ) : (
                        <AiOutlineEye />
                      )}
                    </div>
                  </div>

                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ marginBottom: '32px' }}
                  >
                    <label htmlFor='password'>Confirm Password</label>

                    <Field
                      type={showPassword ? 'text' : 'password'}
                      name='passwordConfirmation'
                      id='password'
                      placeholder='Re- enter your password'
                    />
                    <div
                      className='eye-icon'
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <AiOutlineEyeInvisible />
                      ) : (
                        <AiOutlineEye />
                      )}
                    </div>
                  </div>

                  <Button
                    text={'Reset my password'}
                    className='primary-btn'
                    width='100%'
                    disabled={isSubmitting || !dirty || !isValid}
                    onClick={() => {
                      setConfirmVisible(true);
                      setResetVisible(false);
                    }}
                  />
                </Form>
              )}
            </Formik>
          </div>

          <div className='flex-center' style={{ marginTop: '25px' }}>
            <p
              className='new-user__second'
              onClick={() => setResetVisible(false)}
            >
              Go back to login
            </p>
          </div>
        </div>
      </Modal>

      <Modal
        width={606}
        visible={confirmVisible}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ padding: '40px' }}>
          <div className='modal-head' style={{ marginBottom: '32px' }}>
            <div className='confirm-icon-wrapper'>
              <Verified />
            </div>
            <h2>Password Reset Confirmed</h2>
            <p>
              Your password has been saved successfully, proceed to logging into
              your account with your new password
            </p>
          </div>
          <Button
            text={'Login'}
            className='primary-btn'
            width='100%'
            onClick={() => {
              setConfirmVisible(false);
            }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default Login;
